<style>
@media (min-width: 1024px) {
  .not-found {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}
</style>

<template>
  <div class="not-found">
    <h1>404</h1>
  </div>
</template>
